import React from 'react';

import { MarkedListContainer } from './styles';

interface MarkedListProps {
    children?: React.ReactNode;
}

export const MarkedList: React.FC<MarkedListProps> = ({ children }) => {
    return <MarkedListContainer>{children}</MarkedListContainer>;
};
